module.exports = __webpack_public_path__ + "static/img/rh-active-icon.3e7a0b39.svg";